export const LIVEKIT_SIGNAL_PATH = '/api/live-studio';

const isLoopbackHost = (host) => /^(localhost|127\.0\.0\.1)(:|$)/i.test(String(host || ''));

const withSignalPath = (livekitUrl) => {
  if (!livekitUrl) return livekitUrl;
  try {
    const parsed = new URL(String(livekitUrl).replace(/^ws/i, 'http'));
    if (parsed.pathname && parsed.pathname !== '/') {
      return String(livekitUrl).replace(/\/+$/, '');
    }
    const proto = /^wss:/i.test(livekitUrl) || /^https:/i.test(livekitUrl) ? 'wss:' : 'ws:';
    return `${proto}//${parsed.host}${LIVEKIT_SIGNAL_PATH}`;
  } catch {
    return livekitUrl;
  }
};

const addCandidate = (urls, value) => {
  const url = String(value || '').replace(/\/+$/, '');
  if (!url || urls.includes(url)) return;
  urls.push(url);
};

const hostOf = (url) => {
  try {
    return new URL(String(url).replace(/^ws/i, 'http')).host;
  } catch {
    return '';
  }
};

export function browserLivekitUrlCandidates(
  livekitUrl,
  locationLike = typeof window !== 'undefined' ? window.location : null
) {
  const urls = [];
  const page = locationLike && locationLike.protocol && locationLike.host ? locationLike : null;
  const pageIsLoopback = !!(page && isLoopbackHost(page.host));

  const add = (value) => {
    if (!pageIsLoopback && isLoopbackHost(hostOf(value))) return;
    addCandidate(urls, value);
  };

  if (page && /^https?:$/i.test(page.protocol)) {
    const proto = page.protocol === 'https:' ? 'wss:' : 'ws:';
    add(`${proto}//${page.host}${LIVEKIT_SIGNAL_PATH}`);
    add(`${proto}//${page.host}`);
  }
  add(withSignalPath(livekitUrl));
  if (livekitUrl) {
    try {
      const parsed = new URL(String(livekitUrl).replace(/^ws/i, 'http'));
      const proto = /^wss:/i.test(livekitUrl) || /^https:/i.test(livekitUrl) ? 'wss:' : 'ws:';
      add(`${proto}//${parsed.host}${LIVEKIT_SIGNAL_PATH}`);
      add(`${proto}//${parsed.host}`);
    } catch {
      add(livekitUrl);
    }
  }
  return urls;
}

export function resolveBrowserLivekitUrl(
  livekitUrl,
  locationLike = typeof window !== 'undefined' ? window.location : null
) {
  return browserLivekitUrlCandidates(livekitUrl, locationLike)[0] || livekitUrl;
}

export function resolveApiLivekitUrl(livekitUrl, apiUrl) {
  try {
    if (apiUrl) {
      const api = new URL(apiUrl);
      if (/^https?:$/i.test(api.protocol) && api.host) {
        const proto = api.protocol === 'https:' ? 'wss:' : 'ws:';
        return `${proto}//${api.host}${LIVEKIT_SIGNAL_PATH}`;
      }
    }
  } catch {
    // Fall through to the server-provided URL.
  }
  return withSignalPath(livekitUrl);
}
